import {
  SOCKET_CONNECT,
  SOCKET_EMIT,
  SOCKET_SUBSCRIBE,
  SOCKET_MESSAGE,
  SOCKET_SENDER,
  SOCKET_GATEWAY,
  SOCKET_RESPONSE,
  CLEAR_SOCKET_MESSAGE,
  CLEAR_SOCKET_SENDER,
  CLEAR_SOCKET_GATEWAY,
  CLEAR_SOCKET_RESPONSE,
} from '../mutation_type';

import json5 from 'json5';

const state = {
  connect: false,
  enable: true,
  messageDes: [],
  message: null,
  senderMessageDes: [],
  senderMessage: null,
  gatewayMessageDes: [],
  gatewayMessage: null,
  responseMessageDes: [],
  responseMessage: null,
};

const getters = {
  socketConnect: state => {
    return state.connect;
  },
  socketMessage: state => {
    return state.message;
  },
  socketMessageDes: state => {
    return state.messageDes;
  },
  socketSenderMessage: state => {
    return state.senderMessage;
  },
  socketSenderMessageDes: state => {
    return state.senderMessageDes;
  },
  socketGatewayMessage: state => {
    return state.gatewayMessage;
  },
  socketGatewayMessageDes: state => {
    return state.gatewayMessageDes;
  },
  socketResponseMessage: state => {
    return state.responseMessage;
  },
  socketResponseMessageDes: state => {
    return state.responseMessageDes;
  },
};

const mutations = {
  [SOCKET_CONNECT](state, status) {
    state.connect = status;
  },
  [SOCKET_MESSAGE](state, message) {
    state.message = message;
    state.messageDes.push({ description: message.description, receiveTime: message.receiveTime });
  },
  [CLEAR_SOCKET_MESSAGE]() {
    state.message = '';
    state.messageDes = [];
  },
  [SOCKET_SENDER](state, message) {
    state.senderMessage = message;
    state.senderMessageDes.push({ description: message.description, receiveTime: message.receiveTime });
  },
  [CLEAR_SOCKET_SENDER]() {
    state.senderMessage = '';
    state.senderMessageDes = [];
  },
  [SOCKET_GATEWAY](state, message) {
    state.gatewayMessage = message;
    state.gatewayMessageDes.push({ description: message.description, receiveTime: message.receiveTime });
  },
  [CLEAR_SOCKET_GATEWAY]() {
    state.gatewayMessage = '';
    state.gatewayMessageDes = [];
  },
  [SOCKET_RESPONSE](state, message) {
    state.responseMessage = message;
    state.responseMessageDes.push({ description: message.description, receiveTime: message.receiveTime });
  },
  [CLEAR_SOCKET_RESPONSE]() {
    state.responseMessage = '';
    state.responseMessageDes = [];
  },
  [SOCKET_EMIT](state, payload) {
    state.enable = payload.enable;
    if (!payload.enable) {
      state.message = '';
      state.gatewayMessage = '';
      state.responseMessage = '';
      state.senderMessage = '';
      state.messageDes = [];
      state.gatewayMessageDes = [];
      state.responseMessageDes = [];
      state.senderMessageDes = [];
    }
  },
  [SOCKET_SUBSCRIBE](state, payload) {
    state.message = payload.message;
  },
};

const actions = {
  socketEmit({ commit }, payload) {
    payload.socket.emit(payload.event, payload.params);
    commit('SOCKET_EMIT', payload.params.enable);
  },
  clearSocketMessageDes({ commit }) {
    commit(CLEAR_SOCKET_MESSAGE);
  },
  stopMessage({ commit }, sockets) {
    sockets.unsubscribe('MESSAGE');
    commit(SOCKET_CONNECT);
  },
  startMessage({ commit }, sockets) {
    sockets.subscribe('MESSAGE', data => {
      commit(SOCKET_MESSAGE, json5.parse(data.value));
    });
  },
  clearScketSenderMessageDes({ commit }) {
    commit(CLEAR_SOCKET_SENDER);
  },
  stopSender({ commit }, sockets) {
    sockets.unsubscribe('SENDER');
    commit(SOCKET_CONNECT);
  },
  startSender({ commit }, sockets) {
    sockets.subscribe('SENDER', data => {
      commit(SOCKET_SENDER, json5.parse(data.value));
    });
  },
  clearSocketGatewayMessageDes({ commit }) {
    commit(CLEAR_SOCKET_GATEWAY);
  },
  stopGateway({ commit }, sockets) {
    sockets.unsubscribe('GATEWAY');
    commit(SOCKET_CONNECT);
  },
  startGateway({ commit }, sockets) {
    sockets.subscribe('GATEWAY', data => {
      commit(SOCKET_GATEWAY, json5.parse(data.value));
    });
  },
  clearSocketResponseMessageDes({ commit }) {
    commit(CLEAR_SOCKET_RESPONSE);
  },
  stopResponse({ commit }, sockets) {
    sockets.unsubscribe('RESPONSE');
    commit(SOCKET_CONNECT);
  },
  startResponse({ commit }, sockets) {
    sockets.subscribe('RESPONSE', data => {
      commit(SOCKET_RESPONSE, json5.parse(data.value));
    });
  },
  clearAll({ commit }) {
    commit(CLEAR_SOCKET_MESSAGE);
    commit(CLEAR_SOCKET_SENDER);
    commit(CLEAR_SOCKET_GATEWAY);
    commit(CLEAR_SOCKET_RESPONSE);
  },
  socketSubscribe({ commit }, sockets) {
    sockets.subscribe('MESSAGE', data => {
      commit(SOCKET_MESSAGE, json5.parse(data.value));
    });
    sockets.subscribe('SENDER', data => {
      commit(SOCKET_SENDER, json5.parse(data.value));
    });
    sockets.subscribe('GATEWAY', data => {
      commit(SOCKET_GATEWAY, json5.parse(data.value));
    });
    sockets.subscribe('RESPONSE', data => {
      commit(SOCKET_RESPONSE, json5.parse(data.value));
    });
  },
  socketUnSubscribe({ commit }, sockets) {
    sockets.unsubscribe('RESPONSE');
    sockets.unsubscribe('SENDER');
    sockets.unsubscribe('GATEWAY');
    sockets.unsubscribe('RESPONSE');
    commit(SOCKET_CONNECT);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
